module.exports = __webpack_public_path__ + "6c41ce9c378ec09ac2351c3dcfafbe77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-utubuse.png
// module id = 2039
// module chunks = 4